import { getDays, getHours, getMinutes, getSeconds, hasDays } from '@core/shared';
import { WebinarStatus } from '@core/types';
import { useAppSelector } from '@online-webinar/store';
import { useTranslation } from 'react-i18next';
import { LabelHeading } from '../..';

export const WebinarDuration = () => {
    const { t } = useTranslation();
    const webinarStatus = useAppSelector((state) => state.liveWebinar.webinarData.status);
    const duration = useAppSelector((state) => state.liveWebinar.duration) || 0;
    const showEndWebinarWarning = useAppSelector((state) => state.liveWebinar.showEndWebinarWarning);
    const title = t(webinarStatus === WebinarStatus.Started ? 'Broadcaster.Status.Broadcasting' : 'Broadcaster.Status.Ended');
    const classNames = showEndWebinarWarning ? 'text-warning' : '';

    return (
        <div className="flex flex-col justify-center px-2 md:px-5 min-w-[150px]">
            <LabelHeading name={title} />
            <div className={`font-medium font-accent text-xl relative pr-5 ${classNames}`}>
                <div className="">
                    {hasDays(duration) && <span>{getDays(duration)}&nbsp;</span>}
                    <span>{getHours(duration)}</span>:<span>{getMinutes(duration)}</span>:<span>{getSeconds(duration)}</span>
                </div>
                {webinarStatus === WebinarStatus.Started && (
                    <div className="bg-warning w-3 h-3 rounded-full border-2 border-white shadow-[0_0_0_1px_hsl(var(--c-warning))] absolute right-0 top-1/2 -translate-y-1/2"></div>
                )}
            </div>
        </div>
    );
};
